export const categories = [
    {
        category: 'Clothes',
        children: [
            { category: 'Top',
                children: [
                    {category: 'Blouses'},
                    {category: 'Sweaters'},
                    {category: 'Bralettes'},
                    {category: 'Cargidans'},
                    {category: 'Tops'},
                    {category: 'Vests'},
                    {category: 'Golfs'},
                ] },
            { category: 'Bottom',
            children: [
                {category: 'Shorts'},
                {category: 'Pants'},
                {category: 'Skirts'},
            ] },
            { category: 'Accesories',
                children: [
                    {category: 'Headwear'},
                    {category: 'Socks & slippers'},
                    {category: 'Mittens & gloves'},
                    {category: 'Scarves & shawls'},
                    {category: 'Jewelry'},
                ] },
                { category: 'Dresses'},
                { category: 'Jumpsuits'},
                { category: 'Sets'},
        ],
        
    },
    {
        category: 'Toys',
        children: [
            { category: 'Mascots' },
            { category: 'Accessories' },
            { category: 'Other' },
        ]
    },
    {
        category: 'Decorations',
        children: [
            { category: 'Blankets' },
            { category: 'Figurines' },
            { category: 'Wall decorations' },
            { category: 'Pillows' },
            { category: 'Other' },
        ]
    },
    {
        category: 'Other'
    },
]